import { useEffect, useRef, useState } from "react";
import { ChevronDown, Check } from "lucide-react";

export default function OptionPicker({ value, options, onChange, testid = "option-picker" }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);
  const current = options.find((o) => o.value === value);

  useEffect(() => {
    if (!open) return undefined;
    const away = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("pointerdown", away);
    return () => document.removeEventListener("pointerdown", away);
  }, [open]);

  return (
    <div ref={ref} className="relative notranslate" translate="no">
      <button type="button" onClick={() => setOpen((o) => !o)} data-testid={testid} aria-expanded={open}
        className="w-full h-12 px-4 rounded-md border border-input bg-transparent text-sm flex items-center justify-between press">
        <span>{current?.label || "Escolha"}</span>
        <ChevronDown className={`w-4 h-4 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ul className="absolute z-50 mt-1 w-full max-h-72 overflow-y-auto rounded-xl border border-white/10 bg-card shadow-2xl p-1" role="listbox" data-testid={`${testid}-list`}>
          {options.map((o) => (
            <li key={o.value}>
              <button type="button" onClick={() => { onChange(o.value); setOpen(false); }} data-testid={`${testid}-option-${o.value}`}
                className={`w-full min-h-12 px-4 rounded-lg text-left text-sm flex items-center justify-between press ${o.value === value ? "bg-primary/15 text-primary font-semibold" : "hover:bg-muted"}`}>
                <span>{o.label}</span>
                {o.value === value ? <Check className="w-4 h-4" /> : <span />}
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
